import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import classNames from 'classnames'
import './genericSelect.css'

// Usamos React.forwardRef para que el componente pueda recibir refs
export const GenericSelect = React.forwardRef(({
  onSelectChange,
  placeholder,
  multi = false,
  values,
  name,
  closeMenu = true,
  setValue,
  preValue,
  placeholderAsOption = false,
}, ref) => {



  const [selectedOption, setSelectedOption] = useState()
  const [onBlurError, setOnBlurError] = useState('')
  const [errorMessage, setErrorMessage] = useState(false)
  const [isPreValueSet, setIsPreValueSet] = useState(false)

  useEffect(() => {
    if (onSelectChange) {
      onSelectChange(selectedOption)
    }
  }, [selectedOption, onSelectChange])

  const handleChange = (selectedOption) => {

    setSelectedOption(selectedOption)

    //console.log('setSelectedOption: ', selectedOption)
    //console.log('errorMessage: ', errorMessage)
    //console.log('onblurError: ',onBlurError)
    //👉 Verificamos si es un array de objetos
    if (Array.isArray(selectedOption)) {

      const selectedValues = selectedOption.map(i => i.value)

      setValue(
        name, selectedValues
      )

    } else {

      setValue(name, selectedOption?.value || null)
    }


    setOnBlurError('')
    setErrorMessage(false)
  }


  //! convertirlo a HELPER
  const getValues = () => {

    //console.log('values: ', placeholder)

    if (!values) {
      return values
    }
    let newValues = [
      ...values
    ]

    if (placeholder && placeholderAsOption) {
      newValues = [
        {
          value: '',
          label: placeholder
        },
        ...values
      ]
    }
    //console.log('newValues: ', newValues)
    return newValues

  }




  //? Valor por defecto

  useEffect(() => {
    if (preValue && preValue.length > 0 && !isPreValueSet) {
      setSelectedOption(preValue) //👉 Marcar que preValue ya fue asignado, efecto flag!!
      setValue(name, preValue) //👉 Sincronizar con React Hook Form
      setIsPreValueSet(true) //👉 Marcar que preValue ya fue asignado
    }
  }, [preValue, isPreValueSet, name, setValue])





  const handleBlur = () => {
    if (!selectedOption) {
      setOnBlurError('inErrorSelect')
      setErrorMessage(true)
    }
  }

  return (
    <div className="App w-100">
      <Select
        isSearchable={false}
        name={name}
        // defaultValue={selectedOption}
        value={selectedOption} //?👉 observar esto
        onChange={handleChange}
        // options={values}
        options={getValues()}
        placeholder={placeholder}
        isMulti={multi}
        closeMenuOnSelect={closeMenu}
        className={classNames(onBlurError)} // Aquí la clase 'inErrorSelect' se aplica solo si hay error
        // onBlur={handleBlur}
        ref={ref}
      />

      {errorMessage && (
        <span className='invalid-feedback d-flex field-validation-error'>
          <span className="error-message">Campo requerido</span>
        </span>
      )}
    </div>
  )
})